export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./LeadTransferRulesNotice.vue?vue&type=template&id=4a358102&"


//////////////////
// WEBPACK FOOTER
// ./src/modules/leads/ui/components/LeadTransferRulesNotice.vue?vue&type=template&id=4a358102&
// module id = 1451
// module chunks = 0